import { meetingService } from '../services/meetingservice.js';
import log from '../log.js';

let Vue = null;

function vueSet(array, key, value) {
  if (Vue) {
    Vue.set(array, key, value);
  } else {
    array[key] = value;
  }
}

function vueDelete(array, key) {
  if (Vue) {
    Vue.delete(array, key);
  } else {
    delete array[key];
  }
}

export default {
  namespaced: true,
  state: {
    meetingListInfos: {}
  },
  init: function (vue, store) {
    Vue = vue;
  },
  mutations: {
    setIndex(state, { listId, index }) {
      let item = state.meetingListInfos[listId];
      if (item) {
        vueSet(item, 'index', index);
      }
    },
    meetingListAdded(state, info) {
      vueSet(state.meetingListInfos, info.listId, info);
    },
    meetingListRemoved(state, id) {
      vueDelete(state.meetingListInfos, id);
    },
    meetingListAddMeetings(state, { listId, addedMeetings }) {
      if (addedMeetings.length > 0) {
        let item = state.meetingListInfos[listId];
        item.meetingList = item.meetingList.concat(addedMeetings);

        vueDelete(state.meetingListInfos, listId);
        vueSet(state.meetingListInfos, listId, item);
      }
    },
    meetingListSetMeetings(state, { listId, meetings }) {
      let item = state.meetingListInfos[listId];
      if (item) {
        if (meetings.length > 0) {
          item.meetingList = meetings;
          vueDelete(state.meetingListInfos, listId);
          vueSet(state.meetingListInfos, listId, item);
        } else {
          item.meetingList = [];
          vueDelete(state.meetingListInfos, listId);
          vueSet(state.meetingListInfos, listId, item);
        }
      }
    },
    meetingListSetAllMeetingsLoaded(state, { listId, allMeetingsLoaded }) {
      let item = state.meetingListInfos[listId];
      if (item) {
        item.allMeetingsLoaded = allMeetingsLoaded;
        vueDelete(state.meetingListInfos, listId);
        vueSet(state.meetingListInfos, listId, item);
      }
    }
  },
  getters: {
    getAllMeetingLists: state => {
      let item = state.meetingListInfos;
      return JSON.stringify(item) == "{}" ? null : item;
    },
    getMeetingList: state => listId => {
      let item = state.meetingListInfos[listId];
      return item == null ? [] : item.meetingList;
    },
    newMeetingAdded: state => listId => {
      let item = state.meetingListInfos[listId];
      return item == null ? false : !item.allMeetingsLoaded;
    }
  },
  actions: {
    reRequestMeetingList(context, item) {
      var page_index = item.index + 1;
      if (item.meetingList.length % item.noOfMeetings === 0) {
        page_index++;
      }
      meetingService.getFilteredMeetingList(item.tenancyId, 0, page_index * item.noOfMeetings, item.filter, item.sort).then(response => {
        context.commit('meetingListSetMeetings', { listId: item.listId, meetings: response.meetings });
      }, failure => {
        console.log(failure);
      });
    },
    nextMeetingListPage(context, { listId, successCallback, failureCallback }) {
      let item = getList(context, listId);
      let maxindex = item.index + 1;
      if (item.allMeetingsLoaded) {
        if (successCallback) {
          successCallback();
        }
        return;
      }
      //We do not have a complete page yet, re-request same page
      if (item.meetingList.length < (item.index + 1) * item.noOfMeetings) {
        maxindex = item.index;
      }
      meetingService.getFilteredMeetingList(item.tenancyId, maxindex, item.noOfMeetings, item.filter, item.sort).then(response => {
        let list = item.meetingList;
        let meetings_to_add = [];
        if (list.length > 0 && response.meetings.length > 0) {
          for (var i = 0; i < response.meetings.length; i++) {
            let found = false;
            try {
              for (var j = list.length - 1; j >= list.length - item.noOfMeetings; j--) {
                if (response.meetings[i].project.projectId == list[j].project.projectId) {
                  found = true;
                  break;
                }
              }
            } catch (e) {
              log.error('Meeting list request failed: ' + e);
            }
            if (!found) {
              meetings_to_add.push(response.meetings[i]);
            }
          }
          context.commit('setIndex', { listId, index: maxindex });
          context.commit('meetingListAddMeetings', { listId, addedMeetings: meetings_to_add });
        }
        if (response.meetings.length == 0) {
          context.commit('meetingListSetAllMeetingsLoaded', { listId: listId, allMeetingsLoaded: true });
        }
        if (successCallback) {
          successCallback();
        }
      }, failure => {
        failure.set("Part of the meeting list could not be loaded");
        if (failureCallback) {
          failureCallback(failure);
        }
      });
    },
    addMeetingListListener(context, { tenancyId, filter, sort, noOfMeetings, successCallback, failureCallback }) {
      let lid = getListId(tenancyId, filter, sort, noOfMeetings);
      let info = getList(context, lid);
      let create_info = info == null;

      // create new info
      if (create_info) {
        info = {
          listId: lid,
          tenancyId: tenancyId,
          filter: filter,
          sort: sort,
          meetingList: [],
          index: 0,
          noOfMeetings: noOfMeetings,
          unsubscribe: null,
          allMeetingsLoaded: false
        };
        meetingListListenerCounts[tenancyId] = 0;
      }

      meetingService.getFilteredMeetingList(tenancyId, 0, noOfMeetings, filter, sort).then(response => {
        context.commit('meetingListSetMeetings', { listId: lid, meetings: response.meetings });
        if (successCallback) {
          successCallback();
        }
      }, failure => {
        failure.set("Meeting list could not be loaded");
        if (failureCallback) {
          failureCallback(failure);
        }
      });

      // setup service subscription if we are not already subscribed
      if (meetingListListenerCounts[tenancyId] === 0) {
        // subscribe and add handlers
        let subscription = meetingService.subscribeToMeetingCUDRequestForTenancy(tenancyId);
        subscription.addHandler('MeetingAdditions', msg => {
          if (msg.meetings.length > 0) {
            let tenancy_id = msg.meetings[0].project.tenancyId;
            let items = getLists(context, tenancy_id);

            for (var i = 0; i < items.length; i++) {
              context.commit('meetingListSetAllMeetingsLoaded', { listId: items[i].listId, allMeetingsLoaded: false });
              if (items[i].meetingList.length == 0) {
                context.commit('meetingListSetMeetings', { listId: items[i].listId, meetings: msg.meetings });
              } else {
                if (shouldReRequestMeetingList(items[i], msg.meetings)) {
                  context.dispatch('reRequestMeetingList', items[i]);
                }
              }
            }
          }
        });
        subscription.addHandler('MeetingUpdates', msg => {
          if (msg.meetings.length > 0) {
            let tenancy_id = msg.meetings[0].project.tenancyId;
            let items = getLists(context, tenancy_id);
            for (var i = 0; i < items.length; i++) {
              let list = items[i].meetingList;
              let found = false;
              outer: for (var j = 0; j < msg.meetings.length; j++) {
                for (var k = 0; k < list.length; k++) {
                  if (msg.meetings[j].project.projectId == list[k].project.projectId) {
                    context.dispatch('reRequestMeetingList', items[i]);
                    found = true;
                    break outer;
                  }
                }
              }
              //If we have a MeetingQuestionFilter need to refresh list since question addition
              //will cause a MeetingUpdates broadcast
              if (!found && items[i].filter.map(f => f["@type"] == "MeetingQuestionFilter").length > 0) {
                context.dispatch('reRequestMeetingList', items[i]);
              }
            }
          }
        });
        subscription.addHandler('MeetingDeletes', msg => {
          if (msg.meetingIds.length > 0) {
            for (var id in context.state.meetingListInfos) {
              let item = getList(context, id);
              let list = item.meetingList;
              outer: for (var j = 0; j < msg.meetingIds.length; j++) {
                for (var k = 0; k < list.length; k++) {
                  if (msg.meetingIds[j] == list[k].project.projectId) {
                    //Enough projects have been removed so we need to decrement the page we are on
                    /*if (item.index > 0 && ((item.index + 1) * item.noOfMeetings) > list.length) {
                      let newindex = item.index - 1
                      context.commit('setIndex', {listId: item.listId, index: newindex})
                    }*/
                    context.dispatch('reRequestMeetingList', item);
                    break outer;
                  }
                }
              }
            }
          }
        });
        // create unsubscribe function
        info.unsubscribe = function () {
          meetingListListenerCounts[tenancyId]--;
          context.commit('meetingListRemoved', info.listId);
          if (meetingListListenerCounts[tenancyId] === 0) {
            subscription.unsubscribe();
          }
        };
      }

      // increment listener count
      meetingListListenerCounts[tenancyId]++;

      // add poll info to state
      if (create_info) {
        context.commit('meetingListAdded', info);
      }

      return {
        tenancyId: tenancyId,
        listId: lid,
        remove: () => info.unsubscribe()
      };
    }
  }
};

let meetingListListenerCounts = {};
let filterAndSortIdMap = {};

let ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
let ID_LENGTH = 8;

function generate() {
  //  return Math.floor(Math.random() * Math.floor(1000))

  var rtn = '';
  for (var i = 0; i < ID_LENGTH; i++) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
}

function getListId(tenancyId, filter, sort, noOfMeetings) {
  let key = tenancyId + JSON.stringify(filter) + JSON.stringify(sort) + noOfMeetings;
  if (!filterAndSortIdMap[key]) {
    filterAndSortIdMap[key] = generate();
  }
  return filterAndSortIdMap[key];
}

function shouldReRequestMeetingList(item, meetings) {
  if ((item.index + 1) * item.noOfMeetings + meetings.length > item.meetingList.length) {
    return true;
  } else {
    let lastitem = item.meetingList[item.meetingList.length - 1];
    return checkSort(0, item.sort, meetings, lastitem);
  }
}

function checkSort(index, sorts, meetings, lastitem) {
  let sort = sorts[index];
  let attribute = "createdDate";
  if (sort === "MeetingActivitySort") {
    return checkSort(++index, sorts, meetings, lastitem);
  } else if (sort === "MeetingCreatedDateSort") {
    //implemented, continue
  } else {
    console.debug("sort type " + sort + " not implemented");
  }
  //let attribute = sort["@type"].replace('Sort', '').replace('Meeting', '')
  if (sort.order == "asc") {
    for (var j = 0; j < meetings.length; j++) {
      if (meetings[j].project[attribute] <= lastitem.project[attribute]) {
        if (index >= sorts.length - 1) {
          return true;
        } else {
          return checkSort(++index, sorts, meetings, lastitem);
        }
      }
    }
  } else if (sort.order == "desc") {
    for (var j = 0; j < meetings.length; j++) {
      if (meetings[j].project[attribute] >= lastitem.project[attribute]) {
        if (index >= sorts.length - 1) {
          return true;
        } else {
          return checkSort(++index, sorts, meetings, lastitem);
        }
      }
    }
  }
  return false;
}

function getList(context, id) {
  if (context.state.meetingListInfos != null) {
    return context.state.meetingListInfos[id];
  }
  return null;
}

function getLists(context, tenancyId) {
  let retval = [];
  for (let id in context.state.meetingListInfos) {
    if (context.state.meetingListInfos[id].tenancyId == tenancyId) {
      retval.push(context.state.meetingListInfos[id]);
    }
  }
  return retval;
}


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/meetinglist.js
// module id = null
// module chunks = 